import React from "react";

const ServicesPage = () => {
  const services = [
    {
      id: 1,
      title: "AC Installation & Uninstallation",
      description:
        "Professional AC installation and removal services. We handle split and window ACs with proper fitting and gas charging.",
      icon: "❄️",
      image:
        "https://images.unsplash.com/photo-1617861648989-76a572012089?w=600&q=85",
    },
    {
      id: 2,
      title: "AC Repair & Maintenance",
      description:
        "Complete AC repair services including cooling issues, water leakage, noise problems, and regular maintenance.",
      icon: "🔧",
      image:
        "https://images.unsplash.com/photo-1729183672500-46c52a897de5?w=600&q=85",
    },
    {
      id: 3,
      title: "Gas Refilling & Service",
      description:
        "AC gas refilling with proper pressure testing. We use quality refrigerant for optimal cooling performance.",
      icon: "🌡️",
      image:
        "https://images.unsplash.com/photo-1753964724380-2c5ae02512a8?w=600&q=85",
    },
    {
      id: 4,
      title: "Split AC Repair",
      description:
        "Expert split AC repair services covering compressor issues, PCB problems, indoor/outdoor unit repairs.",
      icon: "💨",
      image:
        "https://images.unsplash.com/photo-1547565687-e6475ec581cf?w=600&q=85",
    },
    {
      id: 5,
      title: "Window AC Repair",
      description:
        "Complete window AC repair including cooling problems, thermostat issues, and general maintenance.",
      icon: "🪟",
      image:
        "https://images.unsplash.com/photo-1617861648989-76a572012089?w=600&q=85",
    },
    {
      id: 6,
      title: "Refrigerator Repair",
      description:
        "Single door and double door fridge repair. Cooling issues, compressor problems, ice formation - we fix it all.",
      icon: "🧊",
      image:
        "https://images.unsplash.com/photo-1647481837638-ebf6d2a060ce?w=600&q=85",
    },
    {
      id: 7,
      title: "Washing Machine Repair",
      description:
        "Top load and front load washing machine repair. Water drainage, spin issues, drum problems solved.",
      icon: "🌀",
      image:
        "https://images.unsplash.com/photo-1742535035610-c5865df05858?w=600&q=85",
    },
    {
      id: 8,
      title: "Microwave Repair",
      description:
        "Microwave oven repair services including heating issues, turntable problems, and electronic repairs.",
      icon: "📻",
      image:
        "https://images.unsplash.com/photo-1584321341057-84aabd4d0399?w=600&q=85",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Header */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Services</h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Complete appliance repair and maintenance services at your doorstep
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden"
                data-testid={`service-card-${service.id}`}
              >
                {/* Service Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4 bg-white rounded-full w-16 h-16 flex items-center justify-center shadow-lg">
                    <span className="text-3xl">{service.icon}</span>
                  </div>
                </div>

                {/* Service Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-700 mb-4">{service.description}</p>

                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:8655557727"
                      className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full font-medium text-center transition-colors duration-200"
                      data-testid={`call-service-${service.id}`}
                    >
                      📞 Call Now
                    </a>
                    <a
                      href={`https://wa.me/918655557727?text=${encodeURIComponent(`Hi, I need ${service.title} service.`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-full font-medium text-center transition-colors duration-200"
                      data-testid={`whatsapp-service-${service.id}`}
                    >
                      💬 WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Book Your Service Now
          </h2>
          <p className="text-lg mb-8 text-blue-100 max-w-2xl mx-auto">
            Don't wait for your appliance to break down completely. Call us for
            preventive maintenance!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:8655557727"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
              data-testid="services-cta-call"
            >
              📞 +91 8655557727
            </a>
            <a
              href="tel:7054773277"
              className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
              data-testid="services-cta-call-2"
            >
              📞 +91 7054773277
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
